<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Report detail</li>
            </ol>
          </div>
          <h4 class="page-title">Report Detail</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Report Detail</h4>
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="row">
              <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert [dismissible]="false" style="width:100%;">
                    <strong>Warning!</strong> {{warning}}
                  </ngb-alert>
                </div>
              </div>

              <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                    <strong>Error!</strong> {{danger}}
                  </ngb-alert>
                </div>
              </div>
            </div>

            <div class="row form-horizontal">
              <div class="col-md-9 form-horizontal px-3">

                <div class="form-group row border-bottom my-3">
                  <label class="col-3 col-form-label font-weight-bold">Select date range</label>
                </div>

                <div class="form-group row">
                  <label class="col-1 col-form-label">Customer</label>
                  <div class="col-2">
                    <ng-select [items]="customers" bindLabel="name" bindValue="id" [(ngModel)]="selectedCustomer" placeholder="Select customer" [searchable]="true"  (change)="onChange($event)" [ngModelOptions]="{standalone: true}">
                    </ng-select>
                  </div>
                  <label class="col-1 col-form-label">Start date</label>
                  <div class="col-2">
                    <input class="form-control" type="date" name="startSate" [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}">
                  </div>
                  <label class="col-1 col-form-label">End date</label>
                  <div class="col-2">
                    <input class="form-control" type="date" name="endDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}">
                  </div>
                  <div class="col-3">
                    <button type="submit" class="btn btn-info waves-effect waves-light" (click)="submit()">
                      View
                    </button>
                  </div>
                </div>

              </div>

            </div>

            <div class="row form-horizontal">
              <div class="form-group row" *ngIf="raiseNoData">
                <div class="col-md-12 form-horizontal px-3">
                  <ngb-alert [dismissible]="false">
                    <strong>{{noData}}</strong>
                  </ngb-alert>
                </div>
              </div>
            </div>

            <div class='bankTransactions' id="DIV_bankTransactions"></div>

            <div class="row" *ngIf="hasData">
              <div class="col-12">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                  <thead>
                    <tr>
                      <th>Merchant name</th>
                      <th>Merchant number</th>
                      <th>Terminal Id</th>
                      <th>Serial number</th>
                      <th>Sim number</th>
                      <th>Make & Model</th>
                      <th>Delivery method</th>
                      <th>Last action date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let terminal of reportData">
                      <td>{{ terminal.merchantName}}</td>
                      <td>{{ terminal.merchantNumber}}</td>
                      <td>{{ terminal.terminalId}}</td>
                      <td>{{ terminal.serialNumber}}</td>
                      <td>{{ terminal.simNumber}}</td>
                      <td>{{ terminal.make}} {{ terminal.model}}</td>
                      <td>{{ terminal.deliveryMethod}}</td>
                      <td>{{ terminal.inUseDate | date}} </td>
                      <td>{{ terminal.status}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12">
                <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="exportToCSV();"> Export to CSV<i class="mdi mdi-plus"></i> </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div> <!-- end container -->
</div>
